import {FC} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'

interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

const FormStep4Parking: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {
    // register,
    setValue,
    // watch,
    // control,
    // formState: {errors},
    // setError,
  } = useFormContext()

  const handleReScan = () => {
    setValue('numeroDocumento', '')
    setValue('isGuest', false)
    setValue('errorCheck', false)
    setValue('HuespedId', '')
    setValue('CamaId', '')
    setValue('ReservaId', '')
    setValue('bookingItem', {})
    goToStep(3)
  }

  const handleExit = () => {
    setValue('numeroDocumento', '')
    setValue('isGuest', false)
    setValue('errorCheck', false)
    setValue('HuespedId', '')
    setValue('CamaId', '')
    setValue('ReservaId', '')
    setValue('bookingItem', {})
    goToStep(2)
  }

  const errorCheck = useWatch({name: 'errorCheck'})
  const operationType = useWatch({name: 'operationType'})
  return (
    <div className='w-100'>
      {errorCheck ? (
        <div className='d-flex justify-content-center flex-column align-items-center'>
          <div>
            <img alt='Exito' src={toAbsoluteUrl('/media/logos/close.png')} />
          </div>
          <div className='d-flex flex-column align-items-center mt-3'>
            <div className='fs-1 fw-bolder'>{`Hubo un error al hacer ${
              operationType === 'checkin' ? 'CheckIn' : 'CheckOut'
            }`}</div>
          </div>
        </div>
      ) : (
        <div className='d-flex justify-content-center flex-column align-items-center'>
          <div>
            <img alt='Exito' src={toAbsoluteUrl('/media/logos/check.png')} />
          </div>
          <div className='d-flex flex-column align-items-center mt-3'>
            <div className='fs-1 fw-bolder'>Éxito</div>
            <div className='fs-3 fw-bolder'>{`${
              operationType === 'checkin' ? 'CheckIn' : 'CheckOut'
            } exitoso`}</div>
            <div className='fs-4 fw-bolder'>{`Su Información ha sido grabada con éxito`}</div>
          </div>
        </div>
      )}
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      <div className='d-flex justify-content-center flex-column align-items-center'>
        <div className='d-flex flex-stack pt-15'>
          <div className='mr-2'>
            <button
              type='button'
              className='btn btn-lg btn-light-primary me-3'
              onClick={handleReScan}
            >
              Reescanear
            </button>
            <button
              type='button'
              className='btn btn-lg btn-light-primary me-3'
              onClick={handleExit}
            >
              Salir
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {FormStep4Parking}
